import React from 'react';
import NumberFormat from 'react-number-format';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import * as S from "./styles";

const Labels = {
  pv: "Investimentos",
  uv: "Retiradas",
  amt: "Ausência de renda",
  inss: "Renda do INSS"
}

const RenderLegend = ({payload}) => {
  return (
    <S.BoxLegend>
      <S.Label>Idade</S.Label>
      {
        payload.map((entry, index) => (
          <S.Legend color={entry.color} key={`item-${index}`}>{Labels[entry.value]}</S.Legend>
        ))
      }
    </S.BoxLegend>
  );
}

const RenderTooltip = ({payload, label}) => {

  return (
    <S.BoxTooltip>
      <S.Item key={`item-tooltip-${label}`}>
        Idade : {label}
      </S.Item>
      {
        payload.map((entry, index) => (
          <S.Item key={`item-tooltip-${index}`}>
            <S.Type color={entry.color}>{`${Labels[entry.dataKey]}: `}</S.Type>
            <NumberFormat
            value={entry.value}
            thousandSeparator={'.'}
            decimalSeparator={','}
            decimalScale={2}
            displayType='text'
            prefix='R$ ' />
          </S.Item>  
        ))
      }
    </S.BoxTooltip>
  );
}

const formatValue = value => {
  const absoluteNumber = Math.abs(Number(value))
  if (absoluteNumber >= 1.0e+9) {
    let label = absoluteNumber >= 2.0e+9 ? " bilhões" : " bilhão";
    return absoluteNumber / 1.0e+9 + label
  } 

  if (absoluteNumber >= 1.0e+6) {
  	let label = absoluteNumber >= 2.0e+6 ? " milhões" : " milhão";
    return absoluteNumber / 1.0e+6 + label
  }

  if (absoluteNumber >= 1.0e+3) {
    return absoluteNumber / 1.0e+3 + " mil"
  } 
    
  return absoluteNumber;
}

export function Graph({data}) {
  return (
    <S.Container>
      <ResponsiveContainer>
        <BarChart
          data={data}
          margin={{top: 5, right: 30, left: 20, bottom: 5}}>
          <CartesianGrid vertical={false} />
          <XAxis dataKey="age" tick={{ fontSize: 10, fill: "#666666"}} stroke="#EEEEEE" />
          <YAxis width={100} tickFormatter={tick => formatValue(tick)} tick={{ fontSize: 14, fill: "#666666"}} stroke="#EEEEEE" />
          <Tooltip content={RenderTooltip} />
          <Legend content={RenderLegend} />
          <Bar dataKey="pv" fill="#9E54FC" barSize={8} radius={[1, 1, 1, 1]} />
          <Bar dataKey="uv" fill="#03DAC6" barSize={8} radius={[1, 1, 1, 1]} />
          <Bar dataKey="amt" fill="#FF0C3E" barSize={8} radius={[1, 1, 1, 1]} />
          <Bar dataKey="inss" fill="#04696B" barSize={8} radius={[1, 1, 1, 1]} />
        </BarChart>
      </ResponsiveContainer>
    </S.Container>
  );
}
